<template>
  <div>
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'groups'}">Groups</router-link>
            <span class="mx-2">/</span>
            <span>{{ record.name || 'Group' }}</span>
          </div>
          <div class="text-xl">
            {{ record.name }} profile
          </div>
        </div>
        <div class=""></div>
      </div>
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class="md:flex block">
        <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
          <div class=" bg-white rounded-lg border shadow-sm">
            <div class="text-center px-3 pb-6 pt-2">
              <h3 class="text-black text-sm bold font-sans">{{ record.name || '' }}</h3>
              <p class="mt-2 font-sans font-light text-grey-dark">{{ record.description }}</p>
            </div>

            <ul class="mt-2 flex flex-wrap md:block">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'group', params: {id: id, path:'customers'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="users" size="16" class="mr-4"></feather>
                  Customers
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'group', params: {id: id, path:'filters'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="filter" size="16" class="mr-4"></feather>
                  Filters
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'group', params: {id: id, path:'settings'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="sliders" size="16" class="mr-4"></feather>
                  Settings
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <div @click="deleteRecord" v-if="$store.getters.can('delete_groups')"
                     class="block items-center flex lg:mt-0 px-3 h-8 hover:text-red-700 text-red-500">
                  <feather type="delete" size="16" class="mr-4"></feather>
                  Delete
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full mt-3 md:mt-0 md:mx-4 ">
          <div v-if="path === 'settings' || path === 'filters'" class="bg-white pt-3 border rounded shadow-sm p-4">
            <NewGroup :e-name="record.name" :e-description="record.description" :title="'Update '+record.name" :id="id"
                      :breadcrumb="false" v-if="path === 'settings'"/>
            <GroupFiltersComponent :id="id" v-else/>
          </div>
          <Customers :groups="[id]" :breadcrumb="false" v-else/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import NewGroup from "@/modules/customers/Groups/NewGroup";
import Customers from "@/modules/customers/Customers";
import GroupFiltersComponent from "@/modules/customers/Groups/GroupFiltersComponent";

export default {
  name: "GroupComponent",
  components: {GroupFiltersComponent, Customers, NewGroup},
  data() {
    return {
      record: Object,
      orgId: this.$store.getters.orgId,
    }
  },
  props: {
    id: String,
    path: String,
  },
  mounted() {
    this.getRecord();
  },
  methods: {
    getRecord() {
      this.loading = true
      GraphQl.sendRequest('{customerGroup(id:"' + this.id + '"){name description id}}')
          .then(response => {
            this.record = response.customerGroup;
          })
    },

    deleteRecord() {
      let delConfirm = confirm("Are you sure you want to delete this customers group?")
      if (delConfirm)
        GraphQl.sendRequest('mutation{deleteCustomerGroup(id: "' + this.id + '"){code message}}')
            .then(response => {
              this.$root.$emit(response.deleteCustomerGroup.code === 200 ? 'alert_success' : 'alert_error', [response.deleteCustomerGroup.message]);
              if (response.deleteCustomerGroup.code === 200)
                this.$router.push({message: 'groups'})
            })
    }
  }
}
</script>

<style scoped>

</style>